import { HStack, VStack } from "@/components/Layout";
import { createFileRoute, useMatch } from "@tanstack/react-router";
import AddressSection from "../../../../-components/PersonProfileSection/personal-information/AddressSection";
import PersonalContactSection from "../../../../-components/PersonProfileSection/personal-information/PersonalContactSection";
import PersonalIdSection from "../../../../-components/PersonProfileSection/personal-information/PersonalIdSection";
import PersonalInformationNavigation from "../../../../-components/PersonProfileSection/personal-information/PersonalInformationNavigation";
import FamilySocialInsuranceAndTaxationSection from "./-components/FamilySocialInsuranceAndTaxationSection";

export const Route = createFileRoute(
  "/_staff/person/$id/_profile/family/$familyPersonId/",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { id: personId, familyPersonId } = useMatch({
    from: "/_staff/person/$id/_profile/family/$familyPersonId/",
    select: (m) => m.params,
  });

  return (
    <HStack className="h-full">
      <nav className="sticky top-0 h-fit w-60 p-8">
        <PersonalInformationNavigation />
      </nav>
      <div className="flex-1 overflow-y-auto p-8">
        <VStack className="w-full gap-4">
          <PersonalIdSection personId={familyPersonId} />
          <PersonalContactSection personId={familyPersonId} />
          <AddressSection personId={familyPersonId} />
          <FamilySocialInsuranceAndTaxationSection
            personId={personId}
            familyPersonId={familyPersonId}
          />
        </VStack>
      </div>
    </HStack>
  );
}
